import { commonFilter } from './filter';

export default {
  pageName: 'ByAccount-Overview',
  pageId: '20106',
  pagePath: '/opinion/Accounts/ByAccount',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
